import { inject, Injectable } from '@angular/core';
import { Query } from '@datorama/akita';

import { createInitialState, FormValuesState, FormValuesStore } from './form-values.store';

@Injectable({ providedIn: 'root' })
export class FormValuesQuery extends Query<FormValuesState> {
  protected store: FormValuesStore;

  constructor() {
    const store = inject(FormValuesStore);

    super(store);

    this.store = store;
  }

  getValuesByFormName(formName: keyof Omit<FormValuesState, 'siteCostsSummary'>) {
    return this.getValue()[formName];
  }

  removeSiteFromPatientBudget(siteId: string) {
    const sites_ids = this.getValuesByFormName('patientBudget').site_ids;
    const updatedSites = sites_ids.filter((id) => id !== siteId);

    this.updateValues({ site_ids: updatedSites }, 'patientBudget');
  }

  resetStore() {
    localStorage.removeItem('formValues');
    this.store.update(createInitialState());
  }

  updateValues<T extends keyof FormValuesState>(data: Partial<FormValuesState[T]>, formName: T) {
    this.store.update((state) => {
      const formValues = {
        ...state,
        [formName]: { ...state[formName], ...data },
      };

      localStorage.setItem('formValues', JSON.stringify(formValues));

      return formValues;
    });
  }
}
